export default __webpack_public_path__ + "static/media/logout_dark.59e9ec42.svg";